import {HttpClient} from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import {Store} from "@ngrx/store";
import {environment} from "../../../../environments/environment";
import {API_ENDPOINTS} from "../../../app.constants";
import {setUserRoles} from "../../../store/actions/auth.actions";

@Injectable({providedIn: "root"})
export class IntrospectionService {
  private readonly httpClient = inject(HttpClient);
  private readonly store = inject(Store);


  public fetchUserRoles() {
    this.httpClient.get(environment.apiGateway + API_ENDPOINTS.INTROSPECTION).subscribe(data => {
      const {groups} = data as {groups: Array<string>};
      this.store.dispatch(setUserRoles({userRoles: groups}));
    });
  }
}
